import React, { Component } from "react";
import { connect } from "react-redux";
import {Container, Col, Row, Table, Form, Input, Button, Alert} from 'reactstrap';
import Header from "./share/Header";
import Map from "./Mapa";
import {zona} from '../actions';
import Loading from "./share/Loading";

class Zonas extends Component {

    constructor(props){
        super(props);
        this.state = {
            codigo_zona: "",
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.getZona(this.state.codigo_zona);
    };

    getDate(date){
        let newDate = new Date(date);
        return `${newDate.getUTCDate()}/${(newDate.getUTCMonth()+1)}/${newDate.getUTCFullYear()}`;
    }

    render(){

        const {data_zona, is_loading, error} = this.props;
        let fecha_siembra = null;
        if(!!data_zona && !!data_zona.fecha_siembra){
            fecha_siembra = this.getDate(data_zona.fecha_siembra);
        }

        return(
            <div>
                <Header/>
                <Container className = 'zonas'>
                    <Row>
                        <h1 className="tituloGeneral mt-4 mb-4 text-center w-100 font-italic font-weight-bold">Zonas</h1>
                    </Row>
                    <Row className="contenedor ml-1 mr-1">
                        <Col md={{size: 6, offset: 0}} sm={{size: 10, offset: 1}} xs={{size: 10, offset: 1}} className="mapa">
                            <h5 className="font-italic text-center">Ingrese el número de la zona a buscar</h5>
                            <Form className="mt-4" onSubmit={this.handleSubmit}>
                                <Row>
                                    <Col md={{size: 8, offset: 1}} sm={{size: 8}} xs={{size: 8}}>
                                        <Input type="number" name="zona" id="zona" placeholder="No. Zona"
                                               onChange={e => this.setState({ codigo_zona: e.target.value })}/>
                                    </Col>
                                    <Col md={2} sm={2} xs={2}>
                                        <Button type="submit">Buscar</Button>
                                    </Col>
                                </Row>
                            </Form>

                            <div className="mt-4">
                                {
                                    (!!data_zona) ?
                                        <Map isMarkerShown latitud={parseFloat(data_zona.latitud)}
                                                         longitud={parseFloat(data_zona.longitud)}/> :
                                        ''
                                }

                            </div>
                        </Col>
                        <Col md={{size: 6, offset: 0}} sm={{size: 10, offset: 1}} xs={{size: 10, offset: 1}} className="caracteristicas">
                            <h2 className="text-center mt-3 font-italic">Generalidades de la zona</h2>
                            {
                                (is_loading) ? <Loading/> : ((error !== null) ?

                                    <Row className="mt-5">
                                        <Col md={{size: 10, offset: 1}}>
                                            <Alert color="danger">
                                                <Container fluid>
                                                    {
                                                            <h3 className="text-center">{error}</h3>
                                                    }

                                                </Container>
                                            </Alert>
                                        </Col>
                                    </Row> :

                                <Table className="mt-5">
                                    <tbody>
                                    <tr>
                                        <th>
                                            <h4>Código de la zona:</h4>
                                        </th>
                                        <td>
                                            {
                                                (!!data_zona && !!data_zona.codigo)?<span>{data_zona.codigo}</span>:<span>-</span>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h4>Ubicación</h4>
                                        </th>
                                        <td>
                                            {
                                                (!!data_zona) ?
                                                    <span>Lat: {data_zona.latitud}, Long: {data_zona.longitud}</span> : <span>Lat: -, Long: -</span>
                                            }

                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <h4>Fecha de siembra:</h4>
                                        </th>
                                        {
                                            (!!fecha_siembra) ? <span>{fecha_siembra}</span> : <span>-</span>
                                        }
                                    </tr>
                                    <tr>
                                        <th>
                                            <h4>Altitud:</h4>
                                        </th>
                                        {
                                            (!!data_zona && !!data_zona.altitud) ? <span>{data_zona.altitud} m</span> : <span>-</span>
                                        }
                                    </tr>
                                    <tr>
                                        <th>
                                            <h4>Temperatura:</h4>
                                        </th>
                                        {
                                            (!!data_zona && !!data_zona.temperatura) ? <span>{data_zona.temperatura} ºC</span> : <span>-</span>
                                        }
                                    </tr>
                                    <tr>
                                        <th>
                                            <h4>Humedad:</h4>
                                        </th>
                                        {
                                            (!!data_zona && !!data_zona.humedad) ? <span>{data_zona.humedad} milimetros</span> : <span>-</span>
                                        }
                                    </tr>
                                    <tr>
                                        <th>
                                            <h4>Clasificación:</h4>
                                        </th>
                                        <td>
                                            {
                                                (!!data_zona && !!data_zona.clasificacion) ? <span>{data_zona.clasificacion.descripcion}</span> : <span>-</span>
                                            }
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>)
                            }
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        data_zona: state.zona.data_zona,
        is_loading: state.zona.is_loading,
        error: state.zona.error
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getZona: (codigo_zona) => {
            return dispatch(zona.getZona(codigo_zona));
        },
        getInitialProps: () => {
            return dispatch(zona.getInitialProps());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Zonas);